import { useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import LoginComponent from "./pages/Login/login";
import InsightsLayout from "./pages/Events/InsightsLayout";
import BuildingsPage from "./pages/Events/BuildingsPage";
import SensorsPage from "./pages/Events/SensorsPage";
import SensorDetailPage from "./pages/Events/SensorDetailPage";
import "./index.css";
import ScrollToTop from "./ScrollToTop";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { muiTheme } from "./theme/MuiTheme";
import Spinner from "./components/ui/Spinner";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

function FullPageLoader() {
  return (
    <div className="spinner">
      <Spinner size={96} />
    </div>
  );
}

const ProtectedRoute = ({ component: Component }) => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect();
    }
  }, [isAuthenticated, loginWithRedirect]);

  return isAuthenticated ? <Component /> : null;
};

const queryClient = new QueryClient();

function App() {
  const { isAuthenticated, isLoading, error } = useAuth0();
  if (isLoading) return <FullPageLoader />;
  if (error)
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        Oops... {error.message}
      </div>
    );
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Router>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route
                path="/"
                element={
                  isAuthenticated ? (
                    <ProtectedRoute component={InsightsLayout} />
                  ) : (
                    <LoginComponent />
                  )
                }
              >
                <Route index element={<BuildingsPage />} />
              </Route>
              <Route path="/login" element={<LoginComponent />} />
              <Route
                path="/insights"
                element={<ProtectedRoute component={InsightsLayout} />}
              >
                <Route index element={<BuildingsPage />} />
                <Route
                  path="properties/:buildingId"
                  element={<SensorsPage />}
                />
                <Route
                  path="properties/:buildingId/sensors/:sensorId"
                  element={<SensorDetailPage />}
                />
              </Route>
            </Routes>
          </Router>
        </LocalizationProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
